var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.titleI18n)?_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.$route.meta.titleI18n)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }